export default "__VITE_ASSET__DsrHQHMA__"